module.exports = __webpack_public_path__ + "images/emoji/pig.a62edd5dfc05aaec5a90.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/pig.png
// module id = ScWA
// module chunks = 14